import PropTypes from "prop-types";
import { _Background_Component } from "@/components/utils/Background/propTypes";
import { _Button_Component } from "@/components/utils/Button/propTypes";
import { _Media_Component } from "@/components/utils/Media/propTypes";

const _Text_Component = PropTypes.shape({
  text_color: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  text_content: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  text_order: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
});

export const _RichContent = PropTypes.shape({
  ..._Button_Component,
  ..._Background_Component,
  ..._Media_Component,
  acf_fc_layout: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  rich_content_content: PropTypes.oneOfType([PropTypes.any, _Text_Component]),
  rich_content_pre_header: PropTypes.oneOfType([PropTypes.any, _Text_Component]),
  rich_content_section_padding: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  rich_content_subtitle: PropTypes.oneOfType([PropTypes.any, _Text_Component]),
  rich_content_title: PropTypes.oneOfType([PropTypes.any, _Text_Component]),
});

const _RichContentComponent = PropTypes.shape({
  component: _RichContent,
});

export const RichContentPropTypes = {
  data: PropTypes.oneOfType([_RichContentComponent, PropTypes.any]),
};
